import script from "./ExchangeTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExchangeTable.vue?vue&type=script&setup=true&lang=ts"

import "./ExchangeTable.vue?vue&type=style&index=0&id=064742ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-064742ec"]])

export default __exports__